import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      margin: theme.spacing(1, 0),
    },
    divider: {
      backgroundColor: COLORS.gray.gray70,
    },
    text: {
      color: COLORS.gray.gray40,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'white',
      padding: theme.spacing(0, 1),
    },
  }),
  { name: 'DividerWithText' }
);
